export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
export const PAYMENT_URL = process.env.NEXT_PUBLIC_PAYMENT_URL;

export const API_VERSION = "/api/v1/";
export const PREFIX = "/api/v1/client/";
// export const OPERATOR = "/api/v1/event-operator/";

export const FULL_BASE_URL = BASE_URL + PREFIX;
export const FULL_BASE_URL_OPS = BASE_URL + API_VERSION;
